<crm-sidepanel></crm-sidepanel>
<glxy-table-container
  [columns]="columns$ | async"
  [groupConfigs]="groupConfigs$ | async"
  [id]="tableId"
  [dataSource]="dataSource"
  [pageSizeOptions]="pageSizeOptions"
  [pageSize]="pageSize"
  [showSelection]="multiRowActionExists$ | async"
  (selectionChanged)="selectionChanged($event)"
  (columnsChanged)="columnsChanged($event)"
  [fullWidth]="true"
>
  <glxy-table-content-header
    [showSort]="false"
    [showActions]="multiRowActionExists$ | async"
    [showFilters]="true"
    [showFiltersOpen]="true"
    [showFiltersApplied]="(showFiltersApplied$ | async) ?? false"
    [saveSearchToQueryParams]="true"
    [columnArrangeType]="'advanced'"
    [showSelectedAllCount]="useSelectAll$ | async"
  >
    <glxy-filter-chips
      [addFiltersHeader]="'TABLE_FILTERS.HEADER' | translateByObjectType: objectTypeForTranslation"
      (filtersChanged)="updateFilters($event)"
      #filterChipRef
      filters-area
    ></glxy-filter-chips>
    <div *ngIf="hasSelectAllActions$ | async" class="selectAllButtons" optional-select-all>
      <div class="select-all-objects">
        <div *ngIf="(useSelectAll$ | async) === false; else clearSelection">
          <a (click)="handleSelectAll()">
            {{
              'LIST_OBJECTS_TABLE.SELECT_ALL.SELECT_ALL_OBJECTS'
                | translateByObjectType: objectType : { totalObjects: dataSource.state.totalDataMembers }
            }}
          </a>
        </div>
      </div>
    </div>
    @if (useSelectAll$ | async) {
      <button
        mat-menu-item
        *ngFor="let action of selectAllActions$ | async"
        (click)="
          action.callback(selectedRows, {
            filters: filters(),
            search: this.dataSource.state.searchTerm,
            useSelectAll: this.dataSource.state.selectAll,
            totalObjects: this.dataSource.state.totalDataMembers
          })
        "
      >
        <span>{{ action.label | translate }}</span>
      </button>
    } @else {
      <button *ngFor="let action of multiRowActions$ | async" mat-menu-item (click)="action.callback(selectedRows)">
        {{ action.label | translate }}
      </button>
    }
    <div after-search class="list-objects-after-search">
      <crm-filter-view
        class="filter-view-button"
        [filters]="filters()"
        (filtersChange)="updateFilters($event, true)"
        [keys]="viewKeys"
      ></crm-filter-view>
    </div>
  </glxy-table-content-header>

  <table mat-table>
    <tr mat-header-row *matHeaderRowDef="[]"></tr>
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <glxy-table-selection></glxy-table-selection>
      </th>
      <td mat-cell *matCellDef="let row">
        <glxy-table-selection [row]="row"></glxy-table-selection>
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row">
        <div>
          <button
            mat-icon-button
            [matMenuTriggerFor]="menu"
            data-testid="actions-button"
            [attr.data-action-group]="'clicked-crm-' + objectTypeForTranslation.toLowerCase() + '-row-action-menu'"
            [attr.data-action]="
              'clicked-crm-' + objectTypeForTranslation.toLowerCase() + '-row-' + row.id + '-action-menu'
            "
          >
            <mat-icon class="actions-menu-button">more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <ng-container *ngFor="let action of singleRowActions$ | async | filterVisibleActions: { row, objectType }">
              <button mat-menu-item (click)="action.callback(row)">
                <span>
                  {{ action.label | translate }}
                </span>
              </button>
            </ng-container>
            <button
              mat-menu-item
              (click)="editObject(row.id)"
              data-testid="edit-crm-object-button"
              [attr.data-action-group]="'clicked-edit-crm-' + objectTypeForTranslation.toLowerCase()"
              [attr.data-action]="'clicked-edit-crm-' + objectTypeForTranslation.toLowerCase() + '-' + row.id"
            >
              <span>
                {{ 'LIST_OBJECTS_TABLE.ACTIONS.EDIT.TITLE' | translateByObjectType: objectTypeForTranslation }}
              </span>
            </button>
            <button
              mat-menu-item
              (click)="deleteObject(row)"
              data-testid="delete-crm-object-button"
              [attr.data-action-group]="'clicked-delete-crm-' + objectTypeForTranslation.toLowerCase()"
              [attr.data-action]="'clicked-delete-crm-' + objectTypeForTranslation.toLowerCase() + '-' + row.id"
            >
              <span>
                {{ 'LIST_OBJECTS_TABLE.ACTIONS.DELETE.ACTION' | translateByObjectType: objectTypeForTranslation }}
              </span>
            </button>
          </mat-menu>
        </div>
      </td>
    </ng-container>
    <tr
      mat-row
      *matRowDef="let row; columns: []"
      [attr.data-testid]="'crm-object-row-' + row.id"
      [ngStyle]="rowStyle?.(row) || {}"
    ></tr>
  </table>
  <glxy-empty-state
    class="empty-table-container"
    *ngIf="showEmptyState$ | async"
    data-testid="crm-objects-table-empty-state"
  >
    <glxy-empty-state-hero>
      <img
        class="empty-state-image"
        src="https://storage.googleapis.com/galaxy-libs-public-images/crm/contacts-empty-state.svg"
        [alt]="'LIST_OBJECTS_TABLE.EMPTY_TABLE.IMAGE_ALT' | translateByObjectType: objectTypeForTranslation"
      />
    </glxy-empty-state-hero>
    <glxy-empty-state-title>
      {{ 'LIST_OBJECTS_TABLE.EMPTY_TABLE.HEADER' | translateByObjectType: objectTypeForTranslation }}
    </glxy-empty-state-title>
    <p>{{ 'LIST_OBJECTS_TABLE.EMPTY_TABLE.HINT' | translateByObjectType: objectTypeForTranslation }}</p>
  </glxy-empty-state>
</glxy-table-container>

<ng-template #clearSelection>
  <div class="selection-count">
    {{
      'LIST_OBJECTS_TABLE.SELECT_ALL.TOTAL_SELECTED'
        | translateByObjectType: objectType : { totalSelected: dataSource.state.totalDataMembers }
    }}
  </div>
  <a (click)="handleSelectAll()">
    {{ 'LIST_OBJECTS_TABLE.SELECT_ALL.CLEAR_SELECTION' | translateByObjectType: objectType }}
  </a>
</ng-template>
